import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=5a1f4d3c&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=5a1f4d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f4d3c",
  null
  
)

export default component.exports